import axios from "_u/axios"

// 公司信息查看明细
export const companyView = (id) => {
    return axios.post("api/company/info/view", { id })
}

// 保存公司信息
export const companySave = (body) => {
    return axios.post("api/company/info/add", body)
}

// 公司信息查看明细
export const companyUpdate = (body) => {
    return axios.post("api/company/info/update", body)
}